import { render, staticRenderFns } from "./ImportTable.vue?vue&type=template&id=1128c30d&"
import script from "./ImportTable.vue?vue&type=script&lang=js&"
export * from "./ImportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports